import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Utility.css";

// Importing icons from React Icons
import { FaDog, FaBolt, FaCoins, FaPaintBrush } from "react-icons/fa";

export default function Transcation() {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  return (
    <div className="main_transcaion_page">
      <div className="container">
        <div
          className="row trans_sc pt-5"
          data-aos="fade-right"
          data-aos-offset="300"
          data-aos-easing="ease-in-sine"
        >
          <div className="col-12 text-center">
            <div className="main-new-cursive mb-4">
              <h1 style={{ fontSize: "3rem" }}>Why PIKU COIN?</h1>
            </div>
          </div>

          <div className="row justify-content-center">
            {/* Card 1 */}
            <div className="col-md-3 mb-4">
              <div className="trns_box_content text-start">
                <div className="icon_container text-center mb-3">
                  <FaDog size={50} color="#ff5733" />
                </div>
                <h6>🐾 Dual Purpose Platform</h6>
                <p className="mt-3">
                piku seamlessly combines gaming and investment, allowing users to enjoy a variety of games while earning PIKUCOIN, which can be used for transactions, investments, or playing other games.
                </p>
              </div>
            </div>

            {/* Card 2 */}
            <div className="col-md-3 mb-4">
              <div className="trns_box_content text-start">
                <div className="icon_container text-center mb-3">
                  <FaBolt size={50} color="#ffbf00" />
                </div>
                <h6>⚡ Early Investment Opportunity</h6>
                <p className="mt-3">
                With the Presale phase, users can secure PIKUCOIN at preferential prices, providing a promising avenue for long-term financial growth as the ecosystem expands.
                </p>
              </div>
            </div>

            {/* Card 3 */}
            <div className="col-md-3 mb-4">
              <div className="trns_box_content text-start">
                <div className="icon_container text-center mb-3">
                  <FaCoins size={50} color="#28a745" />
                </div>
                <h6>💰  Diverse Gaming Options</h6>
                <p className="mt-3">
                piku offers a range of games, including horse racing, tic-tac-toe, chess, and Chinese chess, catering to different preferences and ensuring continuous engagement.
                </p>
              </div>
            </div>

            {/* Card 4 */}
            <div className="col-md-3 mb-4">
              <div className="trns_box_content text-start">
                <div className="icon_container text-center mb-3">
                  <FaPaintBrush size={50} color="#6f42c1" />
                </div>
                <h6>🎨 Transparency and Security </h6>
                <p className="mt-3">
                Built on blockchain technology, piku guarantees fair play, secure transactions, and complete transparency, fostering trust within the community.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
